import { z } from 'zod';

import { PASSWORD_POLICY_RE } from '@/features/auth/schemas/password-policy';

// PRD 09 §3.4 + §10.3 — password change for the medical-staff My Profile page.
// Field error messages are namespace-prefixed i18n keys; the form re-translates
// via `t(errors.field.message)` so the schema stays locale-agnostic.
export const passwordChangeSchema = z
  .object({
    currentPassword: z
      .string()
      .max(64, 'validation:auth.passwordLengthRule')
      .regex(PASSWORD_POLICY_RE, 'validation:auth.passwordRule'),
    newPassword: z
      .string()
      .max(64, 'validation:auth.passwordLengthRule')
      .regex(PASSWORD_POLICY_RE, 'myProfile:passwordChange.errors.policy'),
    confirmPassword: z.string()
  })
  .refine((data) => data.newPassword !== data.currentPassword, {
    message: 'myProfile:passwordChange.errors.sameAsCurrent',
    path: ['newPassword'],
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'myProfile:passwordChange.errors.confirmMismatch',
    path: ['confirmPassword'],
  });

export type PasswordChangeFormValues = z.infer<typeof passwordChangeSchema>;
